export default __webpack_public_path__ + "static/media/eks.575ed9ea.svg";